var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content main-hrm-content" }, [
    _vm._m(0),
    _vm._m(1),
    _c("div", { staticClass: "container functions" }, [
      _c("h3", { staticClass: "services-title" }, [
        _vm._v("HRM管理系统核心职能")
      ]),
      _c(
        "div",
        { staticClass: "functions-body" },
        _vm._l(_vm.functionList, function(val, key) {
          return _c(
            "div",
            {
              key: key,
              staticClass: "functions-item",
              style: {
                backgroundImage: "url(" + val.icon + ")"
              }
            },
            [
              _c("h4", [_vm._v(_vm._s(val.title))]),
              _c("p", [_vm._v(_vm._s(val.text))])
            ]
          )
        }),
        0
      )
    ]),
    _c("div", { staticClass: "container content-body" }, [
      _c("h3", { staticClass: "services-title" }, [
        _vm._v("HRM管理系统核心构成")
      ]),
      _c(
        "div",
        { staticClass: "content-item-list" },
        _vm._l(_vm.content, function(val, key) {
          return _c("div", { key: key, class: ["content-item"] }, [
            _c("img", { attrs: { src: val.icon, alt: "" } }),
            _c("span", [_vm._v(_vm._s(val.text))])
          ])
        }),
        0
      )
    ]),
    _c("h3", { staticClass: "container services-title" }, [
      _vm._v("HRM管理系统管理模式")
    ]),
    _c(
      "div",
      { staticClass: "container content-bootom" },
      _vm._l(_vm.architecture, function(val, key) {
        return _c("div", { key: key, staticClass: "content-bootom-body" }, [
          _c("h3", [_vm._v(_vm._s(val.title))]),
          _c(
            "div",
            { staticClass: "content-bootom-box" },
            _vm._l(val.items, function(item, ix) {
              return _c(
                "div",
                { key: ix, staticClass: "content-bootom-item" },
                [
                  typeof item === "string"
                    ? _c("span", [_vm._v(_vm._s(item))])
                    : typeof item === "object"
                    ? _c(
                        "div",
                        _vm._l(item, function(t, i) {
                          return _c("span", { key: i }, [_vm._v(_vm._s(t))])
                        }),
                        0
                      )
                    : _vm._e()
                ]
              )
            }),
            0
          )
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container content-title" }, [
      _c("h3", { staticClass: "services-title" }, [_vm._v("HRM系统")]),
      _c("p", { staticClass: "container-sub-title" }, [
        _vm._v("提升团队凝聚力，人力资源与业务深度结合")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container content-info" }, [
      _c("div", { staticClass: "content-info-left" }, [
        _c("h3", [_vm._v("HRM管理系统概述")]),
        _c("p", [
          _vm._v(
            "人是企业的核心资源之一，随着竞争越发激烈，企业对人员的要求会越来越高。人对于企业的重要性越发提升，人才的争夺已然成为企业生存竞争的关键。越来越多的企业认知到需要以良好的工作环境、浓厚的文化氛围吸引人才，并为人才施展才华创造平台，也越发需要不断激发人才的潜能，为企业创造应有的价值。"
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32321712", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32321712","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/services/hrm/Content.vue
// module id = wKWZ
// module chunks = 19